var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('router-view',{staticStyle:{"background-color":"#f5f6fd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }